export const SECTORS = 'SECTORS'
export const CATEGORY = 'CATEGORY'
export const SUB_CATEGORY = 'SUB_CATEGORY'
export const SUB_SUB_CATEGORY = 'SUB_SUB_CATEGORY'

export const SECTORPRED = 'SECTORPRED'
export const CATEGORYPRED = 'CATEGORYPRED'
export const MAILINGTYPEPRED = 'MAILINGTYPEPRED'
export const SECCOMPANYPRED = 'SECCOMPANYPRED'

export const RAW_DATA = 'RAW_DATA'

export const MUID = 'MUID'
export const USERID = 'USERID'
export const PRODUCT_OBSERVED_TRAFFIC_SOURCE = 'PRODUCT_OBSERVED_TRAFFIC_SOURCE'
export const PRODUCT_DM_TM_SOURCE = 'PRODUCT_DM_TM_SOURCE'
export const COMPANY_IMG_DATA = 'COMPANY_IMG_DATA'
export const COMPANY_ASSOCIATED_DATA = 'COMPANY_ASSOCIATED_DATA'
export const CURRENT_COMPANY_ID = 'CURRENT_COMPANY_ID'
export const CURRENT_COMPANY_PATH = 'CURRENT_COMPANY_PATH'

export const PRODUCT_ISMOBILE = 'PRODUCT_ISMOBILE'
export const PRODUCT_ISPRESCREEN = 'PRODUCT_ISPRESCREEN'
export const PRODUCT_GROUP_SIZE = 'PRODUCT_GROUP_SIZE'
export const PRODUCT_FACE_AMOUNT = 'PRODUCT_FACE_AMOUNT'
export const PRODUCT_TERM_LENGTH = 'PRODUCT_TERM_LENGTH'
export const PRODUCT_ISSUE_TYPE = 'PRODUCT_ISSUE_TYPE'
export const PRODUCT_RIDERS = 'PRODUCT_RIDERS'
export const PRODUCT_PANELISTS = 'PRODUCT_PANELISTS'
export const PRODUCT_STATE_SPECIFIC = 'PRODUCT_STATE_SPECIFIC'
export const PRODUCT_ENTRYDATE = 'PRODUCT_ENTRYDATE'
export const PRODUCT_OFFER_EXPIRY_DATE = 'PRODUCT_OFFER_EXPIRY_DATE'
export const PRODUCT_VARIENT_ENTRY_ID = 'PRODUCT_VARIENT_ENTRY_ID'
export const PRODUCT_VARIENT_TYPE = 'PRODUCT_VARIENT_TYPE'
export const PRODUCT_COMPANIES = 'PRODUCT_COMPANIES'
export const PRODUCT_PRODUCT_IMAGE = 'PRODUCT_PRODUCT_IMAGE'
export const PRODUCT_IMG = 'PRODUCT_IMG'
export const PRODUCT_AFFINITY = 'PRODUCT_AFFINITY'
export const PRODUCT_MEDIA_CHAN = 'PRODUCT_MEDIA_CHAN'
export const PRODUCT_AUDIENCE = 'PRODUCT_AUDIENCE'
export const PRODUCT_SECTOR_DISPLAYABLE = 'PRODUCT_SECTOR_DISPLAYABLE'
export const PRODUCT_SECTOR_SUBMITTABLE = 'PRODUCT_SECTOR_SUBMITTABLE'
export const PRODUCT_OFFER_ORIGIN = 'PRODUCT_OFFER_ORIGIN'
export const PRODUCT_PRODUCT_NAME = 'PRODUCT_PRODUCT_NAME'
export const PRODUCT_PRODUCT_HEADLINE = 'PRODUCT_PRODUCT_HEADLINE'
export const PRODUCT_WORKTYPE_VOLUNTARY = 'PRODUCT_WORKTYPE_VOLUNTARY'
export const PRODUCT_PRESCREEN_OPNOTICE = 'PRODUCT_PRESCREEN_OPNOTICE'
export const PRODUCT_FEE_PRODUCT = 'PRODUCT_FEE_PRODUCT'
export const PRODUCT_FAUX_CHECK = 'PRODUCT_FAUX_CHECK'
export const PRODUCT_TIP_ON_CARD = "PRODUCT_TIP_ON_CARD";
export const PRODUCT_HANDWRITING = "PRODUCT_HANDWRITING";
export const PRODUCT_PERSCRIPTION = 'PRODUCT_PERSCRIPTION'
export const PRODUCT_IS_HPHSA = 'PRODUCT_IS_HPHSA'
export const PRODUCT_ANCILARY_PRODUCTS = 'PRODUCT_ANCILARY_PRODUCTS'
export const PRODUCT_RESPONSE_MECHANISM = 'PRODUCT_RESPONSE_MECHANISM'
export const PRODUCT_BUSINESS_CONTENT = 'PRODUCT_BUSINESS_CONTENT'
export const PRODUCT_PERSONALIZATION = 'PRODUCT_PERSONALIZATION'
export const PRODUCT_MAILING_TYPE = 'PRODUCT_MAILING_TYPE'
export const PRODUCT_COMMUNICATION_TYPE = 'PRODUCT_COMMUNICATION_TYPE'
export const PRODUCT_ID = 'PRODUCT_ID'

export const SIGN_ON_1_INCENTIVE = 'SIGN_ON_1_INCENTIVE'
export const ONGOING_INCENTIVE = 'ONGOING_INCENTIVE'
export const SIGN_ON_1_INCENTIVE_TYPE = 'SIGN_ON_1_INCENTIVE_TYPE'
export const SIGN_ON_1_INCENTIVE_VALUE = 'SIGN_ON_1_INCENTIVE_VALUE'
export const SIGN_ON_1_ACCELERETOR_PER = 'SIGN_ON_1_ACCELERETOR_PER'
export const SIGN_ON_1_ACCELERETOR_TYPE = 'SIGN_ON_1_ACCELERETOR_TYPE'
export const SIGN_ON_1_MAX_AWARD = 'SIGN_ON_1_MAX_AWARD'
export const SIGN_ON_1_INCENTIVE_MAX_SPEND = 'SIGN_ON_1_INCENTIVE_MAX_SPEND'
export const SIGN_ON_1_INCENTIVE_MIN_SPEND = 'SIGN_ON_1_INCENTIVE_MIN_SPEND'
export const SIGN_ON_1_INCENTIVE_WINDOW_MONTH = 'SIGN_ON_1_INCENTIVE_WINDOW_MONTH'
export const SIGN_ON_1_LIMIT_SPECIFIC_CATEGORY = 'SIGN_ON_1_LIMIT_SPECIFIC_CATEGORY'
export const SIGN_ON_1_FIXED_DATE = 'SIGN_ON_1_FIXED_DATE'

export const SIGN_ON_2_INCENTIVE = 'SIGN_ON_2_INCENTIVE'
export const SIGN_ON_2_INCENTIVE_TYPE = 'SIGN_ON_2_INCENTIVE_TYPE'
export const SIGN_ON_2_INCENTIVE_VALUE = 'SIGN_ON_2_INCENTIVE_VALUE'
export const SIGN_ON_2_ACCELERETOR_PER = 'SIGN_ON_2_ACCELERETOR_PER'
export const SIGN_ON_2_ACCELERETOR_TYPE = 'SIGN_ON_2_ACCELERETOR_TYPE'
export const SIGN_ON_2_MAX_AWARD = 'SIGN_ON_2_MAX_AWARD'
export const SIGN_ON_2_INCENTIVE_MAX_SPEND = 'SIGN_ON_2_INCENTIVE_MAX_SPEND'
export const SIGN_ON_2_INCENTIVE_MIN_SPEND = 'SIGN_ON_2_INCENTIVE_MIN_SPEND'
export const SIGN_ON_2_INCENTIVE_WINDOW_MONTH = 'SIGN_ON_2_INCENTIVE_WINDOW_MONTH'
export const SIGN_ON_2_LIMIT_SPECIFIC_CATEGORY = 'SIGN_ON_2_LIMIT_SPECIFIC_CATEGORY'
export const SIGN_ON_2_FIXED_DATE = 'SIGN_ON_2_FIXED_DATE'

export const SIGN_ON_3_INCENTIVE = 'SIGN_ON_3_INCENTIVE'
export const SIGN_ON_3_INCENTIVE_TYPE = 'SIGN_ON_3_INCENTIVE_TYPE'
export const SIGN_ON_3_INCENTIVE_VALUE = 'SIGN_ON_3_INCENTIVE_VALUE'
export const SIGN_ON_3_ACCELERETOR_PER = 'SIGN_ON_3_ACCELERETOR_PER'
export const SIGN_ON_3_ACCELERETOR_TYPE = 'SIGN_ON_3_ACCELERETOR_TYPE'
export const SIGN_ON_3_MAX_AWARD = 'SIGN_ON_3_MAX_AWARD'
export const SIGN_ON_3_INCENTIVE_MAX_SPEND = 'SIGN_ON_3_INCENTIVE_MAX_SPEND'
export const SIGN_ON_3_INCENTIVE_MIN_SPEND = 'SIGN_ON_3_INCENTIVE_MIN_SPEND'
export const SIGN_ON_3_INCENTIVE_WINDOW_MONTH = 'SIGN_ON_3_INCENTIVE_WINDOW_MONTH'
export const SIGN_ON_3_LIMIT_SPECIFIC_CATEGORY = 'SIGN_ON_3_LIMIT_SPECIFIC_CATEGORY'
export const SIGN_ON_3_FIXED_DATE = 'SIGN_ON_3_FIXED_DATE'

export const PRODUCT_CAMPAIGN_LANGUAGE = 'PRODUCT_CAMPAIGN_LANGUAGE'
export const PRODUCT_TARGET_MARKET = 'PRODUCT_TARGET_MARKET'
export const PRODUCT_STATE_PROVINCE = 'PRODUCT_STATE_PROVINCE'
export const PRODUCT_PRIMARY_COUNTRY = 'PRODUCT_PRIMARY_COUNTRY'
export const PRODUCT_GENDER = 'PRODUCT_GENDER'
export const PRODUCT_AGE = 'PRODUCT_AGE'
export const PRODUCT_INCOME = 'PRODUCT_INCOME'
export const PRODUCT_CITI = 'PRODUCT_CITI'
export const PRODUCT_ON_HOME_PAGE = 'PRODUCT_ON_HOME_PAGE'
export const PRODUCT_HIGH_PRIORITY = 'PRODUCT_HIGH_PRIORITY'
export const PRODUCT_VARIANT_TYPE = 'PRODUCT_VARIANT_TYPE'
export const PRODUCT_VARIENT_ID = 'PRODUCT_VARIENT_ID'

export const BANKING_REWARD_PROGRAM_EMPHASIS = 'BANKING_REWARD_PROGRAM_EMPHASIS'
export const BANKING_REWARD_PROGRAM = 'BANKING_REWARD_PROGRAM'
export const BANKING_CARD_TYPE = 'BANKING_CARD_TYPE'
export const BANKING_DEBIT_CARD_MENTIONED = 'BANKING_DEBIT_CARD_MENTIONED'
export const BANKING_CD_APY = 'BANKING_CD_APY'
export const BANKING_CD_APR = 'BANKING_CD_APR'
export const BANKING_MONEY_MARKET_APY = 'BANKING_MONEY_MARKET_APY'
export const BANKING_MONEY_MARKET_APR = 'BANKING_MONEY_MARKET_APR'
export const BANKING_SAVING_APY = 'BANKING_SAVING_APY'
export const BANKING_SAVING_APR = 'BANKING_SAVING_APR'
export const BANKING_CHECKING_APY = 'BANKING_CHECKING_APY'
export const BANKING_CHECKING_APR = 'BANKING_CHECKING_APR'
export const BANKING_FREE_CHECKING = 'BANKING_FREE_CHECKING'
export const BANKING_MINIMUM_DEPOSIT = 'BANKING_MINIMUM_DEPOSIT'

export const CREDIT_CARD_PROMOTIONAL_OFFER = 'CREDIT_CARD_PROMOTIONAL_OFFER'
export const CREDIT_CARD_TIER_1_BALANCE_TRANSFER_INTRODUCTION_APR = 'CREDIT_CARD_TIER_1_BALANCE_TRANSFER_INTRODUCTION_APR'
export const CREDIT_CARD_TIER_1_BALANCE_TRANSFER_INTRODUCTORY_PERIOD = 'CREDIT_CARD_TIER_1_BALANCE_TRANSFER_INTRODUCTORY_PERIOD'
export const CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTION_APR = 'CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTION_APR'
export const CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTORY_PERIOD = 'CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTORY_PERIOD'
export const CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_USAGE_FEE = 'CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_USAGE_FEE'
export const CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTORY_USAGE_FEE = 'CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTORY_USAGE_FEE'
export const CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MINIMUM_FEE = 'CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MINIMUM_FEE'
export const CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTORY_MINIMUM_FEE = 'CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTORY_MINIMUM_FEE'
export const CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MAXIMUM_FEE = 'CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MAXIMUM_FEE'
export const CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_FEE_PERIOD = 'CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_FEE_PERIOD'
/////
export const CREDIT_CARD_TIER_1_CASH_ADVANCE_INTRODUCTORY_APR = 'CREDIT_CARD_TIER_1_CASH_ADVANCE_INTRODUCTORY_APR'
export const CREDIT_CARD_TIER_1_CASH_ADVANCE_INTRODUCTORY_PERIOD = 'CREDIT_CARD_TIER_1_CASH_ADVANCE_INTRODUCTORY_PERIOD'
export const CREDIT_CARD_TIER_2_CASH_ADVANCE_INTRODUCTORY_APR = 'CREDIT_CARD_TIER_2_CASH_ADVANCE_INTRODUCTORY_APR'
export const CREDIT_CARD_TIER_2_CASH_ADVANCE_INTRODUCTORY_PERIOD = 'CREDIT_CARD_TIER_2_CASH_ADVANCE_INTRODUCTORY_PERIOD'
export const CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_USAGE_FEE = 'CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_USAGE_FEE'
export const CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_MINIMUM_FEE = 'CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_MINIMUM_FEE'
export const CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_MAXIMUM_FEE = 'CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_MAXIMUM_FEE'
export const CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_FEE_PERIOD = 'CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_FEE_PERIOD'
///
export const CREDIT_CARD_TIER_1_PURCHASE_INTRODUCTORY_APR = 'CREDIT_CARD_TIER_1_PURCHASE_INTRODUCTORY_APR'
export const CREDIT_CARD_TIER_1_PURCHASE_INTRODUCTORY_PERIOD = 'CREDIT_CARD_TIER_1_PURCHASE_INTRODUCTORY_PERIOD'
export const CREDIT_CARD_TIER_2_PURCHASE_INTRODUCTORY_APR = 'CREDIT_CARD_TIER_2_PURCHASE_INTRODUCTORY_APR'
export const CREDIT_CARD_TIER_2_PURCHASE_INTRODUCTORY_PERIOD = 'CREDIT_CARD_TIER_2_PURCHASE_INTRODUCTORY_PERIOD'
export const CREDIT_CARD_PURCHASE_INTRODUCTORY_USAGE_FEE = 'CREDIT_CARD_PURCHASE_INTRODUCTORY_USAGE_FEE'
export const CREDIT_CARD_PURCHASE_INTRODUCTORY_MINIMUM_FEE = 'CREDIT_CARD_PURCHASE_INTRODUCTORY_MINIMUM_FEE'
export const CREDIT_CARD_PURCHASE_INTRODUCTORY_MAXIMUM_FEE = 'CREDIT_CARD_PURCHASE_INTRODUCTORY_MAXIMUM_FEE'
export const CREDIT_CARD_PURCHASE_INTRODUCTORY_FEE_PERIOD = 'CREDIT_CARD_PURCHASE_INTRODUCTORY_FEE_PERIOD'
export const CREDIT_CARD_BALANCE_TRANSFER_REGULAR_APR = 'CREDIT_CARD_BALANCE_TRANSFER_REGULAR_APR'
export const CREDIT_CARD_BALANCE_TRANSFER_REGULAR_RATE_TYPE = 'CREDIT_CARD_BALANCE_TRANSFER_REGULAR_RATE_TYPE'
export const CREDIT_CARD_BALANCE_TRANSFER_USAGE_FEE = 'CREDIT_CARD_BALANCE_TRANSFER_USAGE_FEE'
export const CREDIT_CARD_BALANCE_TRANSFER_MINIMUM_FEE = 'CREDIT_CARD_BALANCE_TRANSFER_MINIMUM_FEE'
export const CREDIT_CARD_BALANCE_TRANSFER_MAXIMUM_FEE = 'CREDIT_CARD_BALANCE_TRANSFER_MAXIMUM_FEE'
export const CREDIT_CARD_CASH_ADVANCE_REGULAR_APR = 'CREDIT_CARD_CASH_ADVANCE_REGULAR_APR'
export const CREDIT_CARD_CASH_ADVANCE_REGULAR_RATE_TYPE = 'CREDIT_CARD_CASH_ADVANCE_REGULAR_RATE_TYPE'
export const CREDIT_CARD_CASH_ADVANCE_USAGE_FEE = 'CREDIT_CARD_CASH_ADVANCE_USAGE_FEE'
export const CREDIT_CARD_CASH_ADVANCE_MINIMUM_FEE = 'CREDIT_CARD_CASH_ADVANCE_MINIMUM_FEE'
export const CREDIT_CARD_CASH_ADVANCE_MAXIMUM_FEE = 'CREDIT_CARD_CASH_ADVANCE_MAXIMUM_FEE'
export const CREDIT_CARD_PERCHASE_REGULAR_APR = 'CREDIT_CARD_PERCHASE_REGULAR_APR'
export const CREDIT_CARD_PERCHASE_REGULAR_RATE_TYPE = 'CREDIT_CARD_PERCHASE_REGULAR_RATE_TYPE'

export const DELIVERY_DELIVERY_METHOD = 'DELIVERY_DELIVERY_METHOD'
export const DELIVERY_DELIVERY_TYPE = 'DELIVERY_DELIVERY_TYPE'
export const DELIVERY_POSTAGE = 'DELIVERY_POSTAGE'
export const DELIVERY_PRE_SORTED = 'DELIVERY_PRE_SORTED'
export const DELIVERY_PACKAGE_TYPE = 'DELIVERY_PACKAGE_TYPE'

export const ENERGY_OFFER_PRICE_PER_KWH = 'ENERGY_OFFER_PRICE_PER_KWH'
export const ENERGY_OFFER_PRICE_PER_KWH2 = 'ENERGY_OFFER_PRICE_PER_KWH2'
export const ENERGY_OFFER_PRICE_PER_KWH3 = 'ENERGY_OFFER_PRICE_PER_KWH3'
export const ENERGY_OFFER_PRICE_PER_KWH4 = 'ENERGY_OFFER_PRICE_PER_KWH4'
export const ENERGY_TERM_LENGTH = 'ENERGY_TERM_LENGTH'
export const ENERGY_TERM_LENGTH2 = 'ENERGY_TERM_LENGTH2'
export const ENERGY_TERM_LENGTH3 = 'ENERGY_TERM_LENGTH3'
export const ENERGY_TERM_LENGTH4 = 'ENERGY_TERM_LENGTH4'
export const ENERGY_CANCEL_FEE = 'ENERGY_CANCEL_FEE'
export const ENERGY_CANCEL_FEE_DETAILS = 'ENERGY_CANCEL_FEE_DETAILS'
export const ENERGY_RATE_TYPE = 'ENERGY_RATE_TYPE'
export const ENERGY_RATE_TYPE2 = 'ENERGY_RATE_TYPE2'
export const ENERGY_RATE_TYPE3 = 'ENERGY_RATE_TYPE3'
export const ENERGY_RATE_TYPE4 = 'ENERGY_RATE_TYPE4'

export const MEDIA_CHANNEL_ELECTRONIC_TYPE = 'MEDIA_CHANNEL_ELECTRONIC_TYPE'
export const MEDIA_CHANNEL_DIGITAL_SOURCE = 'MEDIA_CHANNEL_DIGITAL_SOURCE'
export const MEDIA_CHANNEL_NUMBER_UPDATES_TWEETS = 'MEDIA_CHANNEL_NUMBER_UPDATES_TWEETS'
export const MEDIA_CHANNEL_NUMBER_FANS_FOLLOWERS = 'MEDIA_CHANNEL_NUMBER_FANS_FOLLOWERS'
export const MEDIA_CHANNEL_EXTERNAL_LINK = 'MEDIA_CHANNEL_EXTERNAL_LINK'
export const MEDIA_CHANNEL_SOCIAL_MEDIA_ADD_TYPE = 'MEDIA_CHANNEL_SOCIAL_MEDIA_ADD_TYPE'

export const MORTGAGE_LOANS_REFINANCE = 'MORTGAGE_LOANS_REFINANCE'
export const MORTGAGE_LOANS_JUMBO_NON_CONFORMING = 'MORTGAGE_LOANS_JUMBO_NON_CONFORMING'
export const MORTGAGE_LOANS_VA = 'MORTGAGE_LOANS_VA'
export const MORTGAGE_LOANS_FHA = 'MORTGAGE_LOANS_FHA'
export const MORTGAGE_LOANS_CONVENTIONAL = 'MORTGAGE_LOANS_CONVENTIONAL'
export const MORTGAGE_LOANS_USDA = 'MORTGAGE_LOANS_USDA'
export const MORTGAGE_LOANS_CORRESPONDENT_LENDING = 'MORTGAGE_LOANS_CORRESPONDENT_LENDING'
export const MORTGAGE_LOANS_APPLICATION_TYPE = 'MORTGAGE_LOANS_APPLICATION_TYPE'
export const MORTGAGE_LOANS_OFFERED_LOAN_AMOUNT = 'MORTGAGE_LOANS_OFFERED_LOAN_AMOUNT'
export const MORTGAGE_LOANS_MAXIMUM_LOAN_AMOUNT = 'MORTGAGE_LOANS_MAXIMUM_LOAN_AMOUNT'
export const MORTGAGE_LOANS_MINIMUM_LOAN_AMOUNT = 'MORTGAGE_LOANS_MINIMUM_LOAN_AMOUNT'
export const MORTGAGE_LOANS_LOAN_TERM_MONTHS = 'MORTGAGE_LOANS_LOAN_TERM_MONTHS'
export const MORTGAGE_LOANS_OFFERED_APR = 'MORTGAGE_LOANS_OFFERED_APR'
export const MORTGAGE_LOANS_UPPER_APR = 'MORTGAGE_LOANS_UPPER_APR'
export const MORTGAGE_LOANS_LOWER_APR = 'MORTGAGE_LOANS_LOWER_APR'
export const MORTGAGE_LOANS_RATE_TYPE = 'MORTGAGE_LOANS_RATE_TYPE'
export const MORTGAGE_LOANS_INTRODUCTORY_APR = 'MORTGAGE_LOANS_INTRODUCTORY_APR'
export const MORTGAGE_LOANS_INTRODUCTORY_PERIOD_MONTHS = 'MORTGAGE_LOANS_INTRODUCTORY_PERIOD_MONTHS'

export const PAYMENT_CARD_APPLICATION_TYPE = 'PAYMENT_CARD_APPLICATION_TYPE'
export const PAYMENT_CARD_CARD_NETWORK = 'PAYMENT_CARD_CARD_NETWORK'
export const PAYMENT_CARD_PRIMARY_CARD_LEVEL = 'PAYMENT_CARD_PRIMARY_CARD_LEVEL'
export const PAYMENT_CARD_SECONDARY_CARD_LEVEL = 'PAYMENT_CARD_SECONDARY_CARD_LEVEL'
export const PAYMENT_CARD_REWARD_PROGRAM = 'PAYMENT_CARD_REWARD_PROGRAM'
export const PAYMENT_CARD_REWARD_PROGRAM_EMPHASIS = 'PAYMENT_CARD_REWARD_PROGRAM_EMPHASIS'
export const PAYMENT_CARD_REWARD_PROGRAM_RATE = 'PAYMENT_CARD_REWARD_PROGRAM_RATE'
export const PAYMENT_CARD_RELOADABLE = 'PAYMENT_CARD_RELOADABLE'
export const PAYMENT_CARD_TIER_1_PURCHASE_REGULAR_APR = 'PAYMENT_CARD_TIER_1_PURCHASE_REGULAR_APR'
export const PAYMENT_CARD_TIER_2_PURCHASE_REGULAR_APR = 'PAYMENT_CARD_TIER_2_PURCHASE_REGULAR_APR'
export const PAYMENT_CARD_TIER_3_PURCHASE_REGULAR_APR = 'PAYMENT_CARD_TIER_3_PURCHASE_REGULAR_APR'
export const PAYMENT_CARD_PURCHASE_REGULAR_APR_DETAIL = 'PAYMENT_CARD_PURCHASE_REGULAR_APR_DETAIL'
export const PAYMENT_CARD_PERCHASE_REGULAR_RATE_TYPE = 'PAYMENT_CARD_PERCHASE_REGULAR_RATE_TYPE'
export const PAYMENT_CARD_TIER_1_BALANCE_TRANSFER_REGULAR_APR = 'PAYMENT_CARD_TIER_1_BALANCE_TRANSFER_REGULAR_APR'
export const PAYMENT_CARD_TIER_2_BALANCE_TRANSFER_REGULAR_APR = 'PAYMENT_CARD_TIER_2_BALANCE_TRANSFER_REGULAR_APR'
export const PAYMENT_CARD_TIER_3_BALANCE_TRANSFER_REGULAR_APR = 'PAYMENT_CARD_TIER_3_BALANCE_TRANSFER_REGULAR_APR'
export const PAYMENT_CARD_BALANCE_TRANSFER_REGULAR_APR_DETAIL = 'PAYMENT_CARD_BALANCE_TRANSFER_REGULAR_APR_DETAIL'
export const PAYMENT_CARD_BALANCE_TRANSFER_REGULAR_RATE_TYPE = 'PAYMENT_CARD_BALANCE_TRANSFER_REGULAR_RATE_TYPE'
export const PAYMENT_CARD_PENALTY_APR = 'PAYMENT_CARD_PENALTY_APR'
export const PAYMENT_CARD_PENALTY_APR_DETAILS = 'PAYMENT_CARD_PENALTY_APR_DETAILS'
export const PAYMENT_CARD_TIER_1_ANNUAL_FEE = 'PAYMENT_CARD_TIER_1_ANNUAL_FEE'
export const PAYMENT_CARD_TIER_2_ANNUAL_FEE = 'PAYMENT_CARD_TIER_2_ANNUAL_FEE'
export const PAYMENT_CARD_TIER_3_ANNUAL_FEE = 'PAYMENT_CARD_TIER_3_ANNUAL_FEE'
export const PAYMENT_CARD_ANNUAL_FEE_DETAILS = 'PAYMENT_CARD_ANNUAL_FEE_DETAILS'
export const PAYMENT_CARD_TIER_1_LATE_FEE = 'PAYMENT_CARD_TIER_1_LATE_FEE'
export const PAYMENT_CARD_TIER_2_LATE_FEE = 'PAYMENT_CARD_TIER_2_LATE_FEE'
export const PAYMENT_CARD_TIER_3_LATE_FEE = 'PAYMENT_CARD_TIER_3_LATE_FEE'
export const PAYMENT_CARD_LATE_FEE_DETAILS = 'PAYMENT_CARD_LATE_FEE_DETAILS'
export const PAYMENT_CARD_TIER_1_OVERLIMIT_FEE = 'PAYMENT_CARD_TIER_1_OVERLIMIT_FEE'
export const PAYMENT_CARD_TIER_2_OVERLIMIT_FEE = 'PAYMENT_CARD_TIER_2_OVERLIMIT_FEE'
export const PAYMENT_CARD_TIER_3_OVERLIMIT_FEE = 'PAYMENT_CARD_TIER_3_OVERLIMIT_FEE'
export const PAYMENT_CARD_OVERLIMIT_FEE_DETAILS = 'PAYMENT_CARD_OVERLIMIT_FEE_DETAILS'
export const PAYMENT_CARD_BALANCE_TRANSFER_USAGE_FEE = 'PAYMENT_CARD_BALANCE_TRANSFER_USAGE_FEE'
export const PAYMENT_CARD_BALANCE_TRANSFER_MINIMUM_FEE = 'PAYMENT_CARD_BALANCE_TRANSFER_MINIMUM_FEE'
export const PAYMENT_CARD_BALANCE_TRANSFER_MAXIMUN_FEE = 'PAYMENT_CARD_BALANCE_TRANSFER_MAXIMUN_FEE'
export const PAYMENT_CARD_CASH_ADVANCE_USAGE_FEE = 'PAYMENT_CARD_CASH_ADVANCE_USAGE_FEE'
export const PAYMENT_CARD_CASH_ADVANCE_MINIMUM_FEE = 'PAYMENT_CARD_CASH_ADVANCE_MINIMUM_FEE'
export const PAYMENT_CARD_CASH_ADVANCE_MAXIMUM_FEE = 'PAYMENT_CARD_CASH_ADVANCE_MAXIMUM_FEE'
export const PAYMENT_CARD_MINIMUM_CARD_LIMIT = 'PAYMENT_CARD_MINIMUM_CARD_LIMIT'
export const PAYMENT_CARD_MAXIMUM_CARD_LIMIT = 'PAYMENT_CARD_MAXIMUM_CARD_LIMIT'
export const PAYMENT_CARD_MONTHLY_MAINTENENCE_FEE ='PAYMENT_CARD_MONTHLY_MAINTENENCE_FEE'
export const PAYMENT_CARD_STANDARD_MONTHLY_MAINTENENCE_FEE = 'PAYMENT_CARD_STANDARD_MONTHLY_MAINTENENCE_FEE'
export const PAYMENT_CARD_PURCHASE_INTRODUCTORY_APR = 'PAYMENT_CARD_PURCHASE_INTRODUCTORY_APR'
export const PAYMENT_CARD_PURCHASE_INTRODUCTORY_PERIOD_MONTHS = 'PAYMENT_CARD_PURCHASE_INTRODUCTORY_PERIOD_MONTHS'
export const PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_APR = 'PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_APR'
export const PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_PERIOD_MONTHS = 'PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_PERIOD_MONTHS'
export const PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_USAGE_FEE = 'PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_USAGE_FEE'
export const PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MINIMUM_FEE = 'PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MINIMUM_FEE'
export const PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MAXIMUM_FEE = 'PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MAXIMUM_FEE'
export const PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_FEE_PERIOD_MONTHS = 'PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_FEE_PERIOD_MONTHS'
export const PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_FEE_DETAILS = 'PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_FEE_DETAILS'
export const PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_APR = 'PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_APR'
export const PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_PERIOD_MONTHS = 'PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_PERIOD_MONTHS'
export const PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_USAGE_FEE = 'PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_USAGE_FEE'
export const PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_MINIMUM_FEE = 'PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_MINIMUM_FEE'
export const PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_MAXIMUM_FEE = 'PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_MAXIMUM_FEE'
export const PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_FEE_PERIOD_MONTHS = 'PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_FEE_PERIOD_MONTHS'
export const PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_FEE_DETAILS = 'PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_FEE_DETAILS'
export const PAYMENT_CARD_PRODUCT_ID = 'PAYMENT_CARD_PRODUCT_ID'
export const PAYMENT_CARD_BALANCE_TRANSFER_MAXIMUM_FEE = 'PAYMENT_CARD_BALANCE_TRANSFER_MAXIMUM_FEE'
export const PAYMENT_CARD_TIER_1_CASH_ADVANCE_REGULAR_APR = 'PAYMENT_CARD_TIER_1_CASH_ADVANCE_REGULAR_APR'
export const PAYMENT_CARD_TIER_2_CASH_ADVANCE_REGULAR_APR = 'PAYMENT_CARD_TIER_2_CASH_ADVANCE_REGULAR_APR'
export const PAYMENT_CARD_TIER_3_CASH_ADVANCE_REGULAR_APR = 'PAYMENT_CARD_TIER_3_CASH_ADVANCE_REGULAR_APR'
export const PAYMENT_CARD_CASH_ADVANCE_REGULAR_APR_DETAILS = 'PAYMENT_CARD_CASH_ADVANCE_REGULAR_APR_DETAILS'
export const PAYMENT_CARD_CASH_ADVANCE_REGULAR_RATE_TYPE = 'PAYMENT_CARD_CASH_ADVANCE_REGULAR_RATE_TYPE'
export const PAYMENT_CARD_PROMOTIONAL_PRICING_USAGE_OFFER = 'PAYMENT_CARD_PROMOTIONAL_PRICING_USAGE_OFFER'
export const PAYMENT_CARD_PROMOTIONAL_PRICING_USAGE_OFFER_MONTHS = 'PAYMENT_CARD_PROMOTIONAL_PRICING_USAGE_OFFER_MONTHS'

export const RETAIL_CREDIT_CARD_MENTIONED = 'RETAIL_CREDIT_CARD_MENTIONED'

export const TELECOM_PLAN_FEATURED = 'TELECOM_PLAN_FEATURED'
export const TELECOM_FEATURED_PLAN_NAME = 'TELECOM_FEATURED_PLAN_NAME'
export const TELECOM_CONTRACT_REQUIRED = 'TELECOM_CONTRACT_REQUIRED'
export const TELECOM_INTERNET_SPEED = 'TELECOM_INTERNET_SPEED'
export const TELECOM_MONTHLY_COST = 'TELECOM_MONTHLY_COST'
export const TELECOM_LOWER_FEATURED_MONTHLY_COST = 'TELECOM_LOWER_FEATURED_MONTHLY_COST'
export const TELECOM_UPPER_FEATURED_MONTHLY_COST = 'TELECOM_UPPER_FEATURED_MONTHLY_COST'
export const TELECOM_ACTIVATION_CHARGE = 'TELECOM_ACTIVATION_CHARGE'
export const TELECOM_INSTALLATION_CHARGE = 'TELECOM_INSTALLATION_CHARGE'
export const TELECOM_LOCAL_CALLING_MONTHLY_CHARGE = 'TELECOM_LOCAL_CALLING_MONTHLY_CHARGE'
export const TELECOM_LOCAL_DISTANCE_MONTHLY_CHARGE = 'TELECOM_LOCAL_DISTANCE_MONTHLY_CHARGE'
export const TELECOM_LONG_DISTANCE_MONTHLY_CHARGE = 'TELECOM_LONG_DISTANCE_MONTHLY_CHARGE'
export const TELECOM_INTRODUCTORY_COST = 'TELECOM_INTRODUCTORY_COST'
export const TELECOM_INTRODUCTORY_PERIOD_MONTHS = 'TELECOM_INTRODUCTORY_PERIOD_MONTHS'

export const TRAVEL_DEBIT_CARD_MENTIONED = 'TRAVEL_DEBIT_CARD_MENTIONED'
export const TRAVEL_CREDIT_CARD_MENTIONED = 'TRAVEL_CREDIT_CARD_MENTIONED'
export const TRAVEL_CREDIT_NETWORK = 'TRAVEL_CREDIT_NETWORK'
export const REMOVE_PANELIST = 'REMOVE_PANELIST'
export const EDIT_PANELIST = 'EDIT_PANELIST'

export const ADD_PUBLICATION = 'ADD_PUBLICATION'
export const REMOVE_PUBLICATION = 'REMOVE_PUBLICATION'
export const REMOVE_BANKING = 'REMOVE_BANKING'
export const REMOVE_PAYMENT_CARDS = 'REMOVE_PAYMENT_CARDS'
export const REMOVE_CREDIT_CARDS = 'REMOVE_CREDIT_CARDS'
export const REMOVE_ENERGY = 'REMOVE_ENERGY'
export const REMOVE_MORTGAGE = 'REMOVE_MORTGAGE'
export const REMOVE_RETAIL = 'REMOVE_RETAIL'
export const REMOVE_TELECOM = 'REMOVE_TELECOM'
export const REMOVE_TRAVEL = 'REMOVE_TRAVEL'

export const LAST_WORKED_USER = 'LAST_WORKED_USER'

export const INDEX_NAME = 'INDEX_NAME'
export const PRODUCT_STATUS = 'PRODUCT_STATUS'
export const COMMENT = 'COMMENT'
export const PRODUCT_PRODUCT_COMMENT = 'PRODUCT_COMMENT'
export const IS_ADDPRODUCT = 'IS_ADDPRODUCT'
export const EC_CONTENT_TYPE = 'EC_CONTENT_TYPE'

// advertiser

export const ADVERTISER_ADDRESS = 'ADVERTISER_ADDRESS'
export const ADVERTISER_CITY = 'ADVERTISER_CITY'
export const ADVERTISER_STATE = 'ADVERTISER_STATE'
export const ADVERTISER_ZIPCODE = 'ADVERTISER_ZIPCODE'
export const ADVERTISER_PHONE = 'ADVERTISER_PHONE'
export const ADVERTISER_URL = 'ADVERTISER_URL'

// promotions

export const HOLIDAY = 'HOLIDAY'
export const SALE_TYPE = 'SALE_TYPE'
export const PROMOTIONS = 'PROMOTIONS'
//pdf content
export const PDF_CONTENT = 'pdf_content'
//current pdf
export const CURRENT_PDF = 'current_pdf'
export const ENTRY_ID = 'entry_id'
export const ENTRY_DATE_CHANGED = 'entry_date_changed'
export const MOBILE_DIGITAL_FILE_TYPE = 'mobile_digital_file_type'
export const MOBILE_DIGITAL_FILE_URL = 'mobile_digital_file_url'
export const MOBILE_DIGITAL_FILE_SIZE = 'mobile_digital_file_size'
export const MEDIA_CHANNEL_NAME = 'medial_channel_name'
export const BANNER_PRODUCT_PATH = 'banner_product_path'
export const DOCUMENT_SIZE_BYTE = 'document_size_byte'
export const ORIGINAL_DOCUMENT_SIZE = 'original_document_size'
export const IS_MOBILE = "is_mobile"
export const FILE_NAME = 'file_name'
export const PDF_CDN_LINK = 'pdf_cdn_link'
export const PDF_CDN_LINK_ORIG = 'pdf_cdn_link_orig'
export const IS_DELETED = 'is_deleted'
export const DIRECT_MAIL_LOGFILE = 'direct_mail_logfile'
export const ADDED_TO_DATABASE = 'added_to_database'









